import React, { Component } from 'react';
import { Dropdown, FormControl, MenuItem } from 'react-bootstrap';

const SPACE_KEY_CODE = 32;

class SuggestionTextBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            suggestions: []
        };

        this.onTextChange = this.onTextChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onMenuToggle = this.onMenuToggle.bind(this);
        this.onSuggestionsReceived = this.onSuggestionsReceived.bind(this);
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.setInputReference = this.setInputReference.bind(this);

        this.menuOpen = false;
        this.lastSearchTime = 0;
    }

    onTextChange(e) {
        let currentText = e.target.value;
        let currentTime = new Date().getTime();
        if((currentText.length >= this.props.minLengthForSearch) &&
            ((currentText.length - this.props.minLengthForSearch) % this.props.searchFrequency === 0) &&
            (this.props.searchDelay <= 0 || (currentTime - this.lastSearchTime >= this.props.searchDelay))) {
            this.lastSearchTime = currentTime;
            this.props.getSuggestions(currentText, this.onSuggestionsReceived);
        }

        if(typeof(this.inputRef) !== "undefined" &&
            typeof(this.state.suggestions.find(s => s.text === currentText)) === "undefined") {
            this.inputRef.name = ""; // Reset the key of the suggestion if the text no longer matches
        }
    }

    onKeyDown(e) {
        if(e.keyCode === SPACE_KEY_CODE) {
            e.stopPropagation(); // This is needed to stop the menu from "eating" the space and use it to toggle, instead we want it as input
        }
    }

    onBlur(e) {
        // Remove text that doesn't match a known competitor when we leave the input area
        let currentText = e.target.value;
        if(typeof(this.inputRef) !== "undefined" &&
            typeof(this.state.suggestions.find(s => s.text === currentText)) === "undefined") {
            this.inputRef.value = "";
            this.inputRef.name = "";
        }
    }

    onMenuToggle(isOpen, e, source) {
        this.menuOpen = isOpen; // This is needed to keep track of the menu's state and force it open if necessary when we get new suggestions
    }

    onSuggestionsReceived(suggestions) {
        if(typeof(suggestions) !== "undefined") {
            if(!this.menuOpen && typeof(this.inputRef) !== "undefined") { // Force the menu open when new suggestions arrive
                this.inputRef.click();
            }
            this.setState({"suggestions": suggestions});
        }
    }

    onSuggestionSelected(suggestion, e) {
        if(typeof(this.inputRef) !== "undefined") {
            this.inputRef.value = suggestion;
            this.inputRef.name = e.target.name;
        }
    }

    setInputReference(ref) {
        this.inputRef = ref;

        this.props.inputReference(ref);
    }

    render() {
        let suggestionItems = this.state.suggestions.map((s, index) =>
            <MenuItem name={s.key} key={index} eventKey={s.text}>{s.text}</MenuItem>);

        let anySuggestionItems = suggestionItems.length > 0;

        return (
            <Dropdown id="suggestionDropdown" className="SuggestionTextBox-dropdown"
                onSelect={this.onSuggestionSelected} onToggle={this.onMenuToggle}>
                <Dropdown.Toggle noCaret="true" useAnchor="false">
                    <FormControl className="SuggestionTextBox-input"
                        key={this.props.inputKey} id={this.props.inputId} name=""
                        value={this.props.inputValue} placeholder={this.props.placeholderText} type="text"
                        onChange={this.onTextChange} onKeyDown={this.onKeyDown}
                        onBlur={this.onBlur} inputRef={this.setInputReference} autoComplete="off" />
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ display: (anySuggestionItems ? "" : "none") }}>
                    { suggestionItems }
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

export default SuggestionTextBox;


// WEBPACK FOOTER //
// ./src/components/SuggestionTextBox.js